<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" fill="none"><path d="M5.002 5.648a.71.71 0 0 1-.457-.165L.258 1.88A.723.723 0 0 1 .65.607a.711.711 0 0 1 .523.164l3.83 3.228L8.831.885a.712.712 0 0 1 1.007.108.722.722 0 0 1-.1 1.052l-4.287 3.48a.71.71 0 0 1-.45.122Z"/></svg>
</template>

<script>
export default {
  name: 'icon-chevron-down'
}
</script>
